import { render } from "./HighLevelWeeklyReport.vue?vue&type=template&id=d054dd7a&scoped=true"
import script from "./HighLevelWeeklyReport.vue?vue&type=script&lang=js"
export * from "./HighLevelWeeklyReport.vue?vue&type=script&lang=js"

import "./HighLevelWeeklyReport.vue?vue&type=style&index=0&id=d054dd7a&scoped=true&lang=css"

import exportComponent from "C:\\Users\\shuha\\Documents\\Wisdom guide front\\wg-frontend-v1\\node_modules\\vue-loader-v16\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-d054dd7a"]])

export default __exports__